import { SVG } from '../svg';
import { IconProps } from '../types';

export function InfoIcon(props: IconProps): JSX.Element {
  return (
    <SVG {...props}>
      <circle cx="12" cy="12" r="10" />
      <path d="M12 16v-4" />
      <path d="M12 8h.01" />
    </SVG>
  );
}
